var packageName = "@atlassian/recent-work-client";
var packageVersion = "2.0.1";
export { packageName, packageVersion };